module.exports = __webpack_public_path__ + "img/user.81ee9398.png";